// extracted by mini-css-extract-plugin
module.exports = {"uploadBuildInModal":"UploadBuild_uploadBuildInModal__2QpT0","detailsInPushBuildModal":"UploadBuild_detailsInPushBuildModal__k1U2H"};